import { InputLoader } from '../GlobalComponents/Inputs/Inputs'

export const InputLoadingStory = () => {
    return (
        <>
            <InputLoader
                style={{
                    maxHeight: 15,
                    marginLeft: 10,
                    width: 15,
                    display: 'inline-flex',
                }}
            />

            <div style={{ marginTop: 20, fontWeight: 'bold', fontStyle: 'italic' }}>
                Note: Typically used for loading in inputs
            </div>
        </>
    )
}

export const PageLoadingStory = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className={'k-i-loading'} style={{ fontSize: 200, height: '90vh' }} />
        </div>
    )
}
